import { useParams } from 'react-router-dom';

import { isFlowDataType, type FlowDataType } from '../../flow-data-type';

export const useFlowDataTypeParam = (
  defaultFlowDataType: FlowDataType = 'device',
) => {
  const { flowDataType } = useParams();

  if (isFlowDataType(flowDataType)) {
    return flowDataType;
  }

  return defaultFlowDataType;
};
